import { useState } from "react";
import { useMutation } from "@apollo/client";
import {
  Anchor,
  Button,
  PasswordInput,
  Space,
  Text,
  TextInput,
} from "@mantine/core";
// import axios from 'axios'; // added for tracking user data
import { AUTH_TOKEN } from "../../../constants/authToken";
import { LOGIN_MUTATION } from "../../../queries/auth";
// import { ADD_LOG } from "../../../queries/user-analytics";
import { useNavigate } from "react-router-dom";

import "./LoginForm.css";

export default function LoginForm({ setIsLoginMode }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // added for tracking user data
//   const [logEventMutation] = useMutation(ADD_LOG, {
//     onCompleted: ({ response }) => {
//         // Access the HTTP response directly
//         const { status, message } = response.logEvent;
//         if (status === "success") {
//             console.log("Event logged successfully:", message);
//         } else {
//             console.error("Failed to log event:", message);
//         }
//     },
//     onError: (error) => {
//         console.error("Error logging event:", error.message);
//     }
// });

//   const logEvent = (eventType, additionalData, _userid) => {
//       const eventData = {
//           userId:_userid ,
//           event_type: eventType,
//           timestamp: new Date().toISOString(),
//           additional_data: additionalData

//       };

//       logEventMutation({ variables: eventData });
//   };


  const [startLogin] = useMutation(LOGIN_MUTATION, {
    onError: (error) => {
      console.log("Login error:", error);
      alert("Incorrect phone number or password. Please try again.");
    },
    onCompleted: ({ login }) => {
      console.log(login.error);
      // logEvent('Login', null)
      if (login.response) {
        // logEvent('Login',{ response: login.response } , 1); // Log the login event
        localStorage.setItem(AUTH_TOKEN, login.response);
        window.location.href = "/journey";
      } else {
        alert("Incorrect phone number or password. Please try again.");
      }
    },
  });

  const handleLogin = () => {
    if (!email || !password) {
      alert("Please enter both email and password.");
      return;
    }
    

    startLogin({
      variables: {
        email,
        password,
      },
    });
  };

  return (
    <div className="login-form">
      <div className="form-container">
        <TextInput
          placeholder="example@gmail.com"
          label="Email Address"
          size="md"
          value={email}
          onChange={(event) => setEmail(event.currentTarget.value)}
        />
        <Space h="lg" />
        <PasswordInput
          placeholder="Password"
          label="Password"
          size="md"
          value={password}
          onChange={(event) => setPassword(event.currentTarget.value)}
        />
        <Space h="xs" />
        <Text align="right" size="sm">
          <Anchor 
            onClick={() => navigate('/forgot-password')}
            style={{ fontWeight: 500 }}
          >
            Forgot password?
          </Anchor>
        </Text>
        <Space h="xl" />
        <div className="button-container">
          <Button
            fullWidth
            variant="filled"
            size="md"
            onClick={handleLogin}
            className="button"
          >
            Log In
          </Button>
        </div>
        <Space h="lg" />
        <Text align="center">Don't have an account yet? </Text>
        <Text align="center">
          <Anchor onClick={() => {
            setIsLoginMode(false);
            navigate('/register');
          }} className="text" component="button">
            Create an Account
          </Anchor>
        </Text>
      </div>
    </div>
  );
}
